/**
 * bootprompt.js locale configuration
 * locale : German
 * author : Nick Payne
 */

import { addLocale } from "../bootprompt";

addLocale("de", {
  OK: "OK",
  CANCEL: "Abbrechen",
  CONFIRM: "Akzeptieren",
});
